import { gql } from "@apollo/client";

export const CHANGE_STATE_VALIDAR_INSUMO = gql`
    mutation ChangeValidarInsumo($input: ValidarInsumoInput!)
    {
    changeValidarInsumo(input: $input)
    {    
        idInsumoN
    }
}`;